import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { EnvironmentService } from "../environment.service";
import { isSameOriginPublicApi } from "./api-origin.util";

export interface GeneratedToken {
  access_token?: string;
  expires_in: string | number;
  created_at?: string;
}

@Injectable()
export class PublicClientService {
  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  private get base_url(): string {
    return this.environmentService.get("api.url") || "";
  }

  /**
   * Anonymous public login.
   * With website BFF: sets HttpOnly cookie and returns body without access_token.
   * Without BFF (direct API / legacy): may still return access_token for localStorage fallback.
   */
  login(): Observable<GeneratedToken> {
    const options = isSameOriginPublicApi(this.base_url) ? { withCredentials: true } : {};
    return this.http.post<GeneratedToken>(`${this.base_url}/signin_public`, {}, options);
  }
}
